import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GroupsAddPage } from './groups-add';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    GroupsAddPage
  ],
  imports: [
    IonicPageModule.forChild(GroupsAddPage),
    DirectivesModule
  ],
})
export class GroupsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/groups-add/groups-add.module.ts